import { ReactNode } from "react"
import {
  Block,
  Button,
  ButtonProps,
  HeadingXSmall,
  LinkExternal02,
} from "@mezo-org/mezo-clay"

type HomepageExploreSectionContainerProps = {
  title: string
  children: ReactNode
  buttonText: ReactNode
  buttonProps?: ButtonProps
}

export default function HomepageExploreSectionContainer({
  title,
  children,
  buttonText,
  buttonProps,
}: HomepageExploreSectionContainerProps) {
  return (
    <Block
      backgroundColor="white"
      overrides={{ Block: { style: () => ({ borderRadius: "12px" }) } }}
    >
      <HeadingXSmall padding="16px">{title}</HeadingXSmall>
      {children}
      <Block padding="16px">
        <Button
          size="small"
          kind="secondary"
          $as="a"
          startEnhancer={<LinkExternal02 size={16} color="contentPrimary" />}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      </Block>
    </Block>
  )
}
